import $ from "jquery";

// Update the canonical url in the <head>.
const updateCanonical = (canonicalPath) => {
  const canonicalNode = $("link[rel=canonical]");
  const canonicalBase = canonicalNode.data("default");
  const canonicalUrl = `${canonicalBase}${canonicalPath.slice(1)}`;

  canonicalNode.attr("href", canonicalUrl);
};

// Explicitly set a page's canonical url, by updating the canonical url in the <head>.
// Keep it in page data (for subsequent default use on showing the page).
export const updatePageCanonicalUrl = ($page, canonicalUrl) => {
  $page.data("canonical-url", canonicalUrl);
  updateCanonical(canonicalUrl);
};

// On showing a page, update the canonical url in the <head>.
//
// If the page has a canonical url set, use it.
// Default to using home page for canonical.
export const addPageNavigationUpdateCanonicalUrl = () => {
  $("[data-role=page]").on("pageshow", function () {
    const pageCanonical = $(this).data("canonical-url") || "/";

    updateCanonical(pageCanonical);
  });
};
